import { createComponent } from '@carvana/merch-components';
import { Radio } from '@carvana/showroom-forms';
import styles from './Trade.module.css';

export const GreyBar = createComponent('hr', {
  className: 'w-full border-t border-grey-2'
});

export const CustomRadio = createComponent(Radio, {
  className: `items-start tl-body-m ${styles.tradeRadio}`
});
